module.exports = __webpack_public_path__ + "static/media/10.3fc47fdd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/files/10.jpeg
// module id = 83
// module chunks = 0